import axios from "axios";
const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const sendContestForm = (hubspotData, contestSlug) => {
    hubspotData.hubspot_utk = getCookie('hubspotutk');
    const laravelAuthToken = localStorage.getItem('laravelAuthToken');
    const authHeaders = {
        headers: {"Authorization": `Bearer ${laravelAuthToken}`}
    };
    return axios.post(`/api/hubspot/${contestSlug}/submit-hubspot-form`, hubspotData, authHeaders)
}

export {
    sendContestForm,
}